export enum RequiredStorageKeys {

    KEY_AUTH_REFRESH_TOKEN = 'auth_refresh_token', //DO not change
    KEY_AUTH_EXPIRES = 'auth_expires', //DO not change
    KEY_AUTH_EXPIRES_DATE = 'auth_expires_date', //DO not change
    KEY_AUTH_ACCESS_TOKEN = 'auth_token', //DO not change

    CACHED_THEME = 'cached_theme',
    CACHED_USER = 'cached_user',
    CACHED_SERVER_INFO = 'cached_server_info',

    COOKIE_CONFIG = 'cookie_config',
    IS_ANONYMOUS = 'isAnonymous',

    CACHED_DRAWER_CONFIG = 'cached_drawer_config',
}
